import {
  GET_PARTICULAR_ENTERPRISE,
  GET_PARTICULAR_ENTERPRISE_SUCCESS,
  GET_PARTICULAR_ENTERPRISE_FAILURE,
} from './action';

const initialState = {
  loading: false,
  users: [],
  error: '',
};

const getParticularEnterpriseReducer = (state = initialState, action) => {
  switch (action.type) {
    case GET_PARTICULAR_ENTERPRISE:
      return { ...state, loading: true };
    case GET_PARTICULAR_ENTERPRISE_SUCCESS:
      return { ...state, loading: false, users: action.payload, error: '' };
    case GET_PARTICULAR_ENTERPRISE_FAILURE:
      return { ...state, loading: false, users: [], error: action.payload };
    default:
      return state;
  }
};

export default getParticularEnterpriseReducer;
